import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {ConfirmationModalComponent} from './confirmation-modal.component';
import {take} from 'rxjs';

export interface ConfirmationProps {
    title: string;
    confirmationText: string;
    action?: string;
    yes?: string;
    no?: string;
    showCancel?: boolean;
    iconType?: 'info' | 'warning';
}

@Injectable({
    providedIn: 'root'
})
export class ConfirmationModalService extends ModalService {
    testModal() {
        this.showModal({
            title: 'Warning',
            confirmationText: 'Are you sure you wish to continue?',
            action: 'test:press_ok'
        }).subscribe(data => {
            if (data === 'test:press_ok') {
                console.log('Pressed Ok');
            }
        });
    }

    showModal(props: ConfirmationProps) {
        this.createModalComponent(ConfirmationModalComponent);
        const confirmationModalComponentInstance = this.modalComponentRef.instance as ConfirmationModalComponent;
        confirmationModalComponentInstance.title = props.title;
        confirmationModalComponentInstance.confirmationText = props.confirmationText;
        confirmationModalComponentInstance.yes = props.yes;
        confirmationModalComponentInstance.no = props.no;
        confirmationModalComponentInstance.showCancel = !!props.showCancel;
        confirmationModalComponentInstance.action = props.action ?? confirmationModalComponentInstance.action;
        confirmationModalComponentInstance.iconType = props.iconType || 'warning';
        this.showModalComponent();
        return confirmationModalComponentInstance.modalClosed.pipe(take(1));
    }
}
